import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  PersistentInfoSnackbarComponent
} from "../dashboard/components/persistent-info-snackbar/persistent-info-snackbar.component";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showError(message: string, duration: number = 4000) {
    this.snackBar.open(message, 'Sluiten', {
      duration,
      panelClass: 'snackbar-error',
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

  showSuccess(message: string, duration: number = 3000) {
    this.snackBar.open(message, 'Sluiten', {
      duration,
      panelClass: 'snackbar-success',
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

  showInfo(message: string, duration: number = 3000) {
    this.snackBar.open(message, 'Sluiten', {
      duration,
      panelClass: 'snackbar-info',
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

  showPersistent(message: string) {
    this.snackBar.openFromComponent(PersistentInfoSnackbarComponent, {
      data: { message },
      panelClass: 'snackbar-persistent-info',
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}

